import { get } from "lodash"

const EMPTY_ARRAY = []

export const getSolutions = state => get(state, "global.data.solutions.data.solutions", EMPTY_ARRAY)
